<template>
	<div class="default-input default-input--search" :class="{'default-input--error' : errors.length, 'default-input--bg' : inputGray }">
		<label class="default-input__label" v-if="label" :for="id">{{ label }}</label>
		<div class="default-input__wrapper">
			<div class="default-input__input default-input__input--search">
				<input type="search" v-model="value" :placeholder="placeholder" :id="id" :disabled="disabled" @keydown.enter.prevent="$emit('search')">
			</div>
			<button class="default-input__btn default-input__btn--search" v-if="actionBtn" @click="$emit('search')">Найти</button>
		</div>
		<ul v-if="errors.length" class="default-input__errors">
			<li>{{ errors[0].$message }}</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: "InputSearch",
	emits:['update:modelValue', "search"],
	props: {
		modelValue: {
			type: String,
			default: ''
		},
		id: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: ''
		},
		placeholder: {
			type: String,
			default: 'Поиск'
		},
		disabled: {
			type: Boolean,
			default: false
		},
		actionBtn: {
			type: Boolean,
			default: false
		},
		errors: {
			type: Array,
			default: () => []
		},
		inputGray: {
			type: Boolean,
			default: false
		},
	},
	computed: {
		value: {
			get() {
				return this.modelValue
			},
			set(value) {
				this.$emit('update:modelValue', value)
			}
		}
	}
}
</script>


